export var AdvancedSortingDiretion;
(function (AdvancedSortingDiretion) {
    AdvancedSortingDiretion["Ascending"] = "ASC";
    AdvancedSortingDiretion["Descending"] = "DESC";
})(AdvancedSortingDiretion || (AdvancedSortingDiretion = {}));
